"use strict";

import Vue from 'vue';
import axios from "axios";
import qs from 'qs'
import store from '../store/store'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// apiUrl: 'http://crm.api' ,
let config = {
  baseURL: process.env.BASE_URL,
  timeout: 60 * 1000, // Timeout
  headers:{
    'Authorization': 'Bearer'
  },
   withCredentials: true//Check cross-site Access-Control
}

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    if (store.state.token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `Bearer ${store.state.token}`;
    }
    return config;
  },
  function (error) {
    // Do something with request error

    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:

          // 返回 401 清除token信息并跳转到登录页面
          store.commit("setToken", "");
          router.replace({
            path: 'login',
            query: {redirect: router.currentRoute.fullPath}
          })
      }
    }
    // Do something with response error
    return Promise.reject(error);
  }
);
_axios.interceptors.request.use(
  function (request) {
    // Do something with response data
    return request;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);


_axios._get = function (path, query) {
  return new Promise((resolve, reject)=>{
    config.params = query;
    _axios.get(path, config).then(function (resp) {
      resolve(resp.data);
    }).catch(function (err) {
      console.log(err);
      reject(err);
    });
  })
}

_axios._getQuery = function (path, pathQuery) {
  return new Promise((resolve, reject)=>{
    config.params = null;
    path += '?' + qs.stringify(pathQuery);
    _axios.get(path, config).then(function (resp) {
      resolve(resp.data);
    }).catch(function (err) {
      console.log(err);
      reject(err);
    });
  })
}

_axios._post = function (path, data) {
  return new Promise((resolve, reject)=>{
    config.params = null;
    config.data = qs.stringify(data);
    _axios.post(path, data,config).then(function (resp) {
      resolve(resp.data);
    }).catch(function (err) {
      console.log(err);
      reject(err);
    });
  })
}
_axios.postUrlEncoded=function (path, data) {
  return new Promise((resolve, reject) => {
    config.headers.ContentType = 'application/x-www-form-urlencoded';
    config.params = null;
    config.data = data;
    axios.post(path, qs.stringify(data), config).then(function (resp) {
      resolve(resp.data);
    }).catch(function (err) {
      console.log("error is: ");
      console.log(err);
      reject(err);
    })
  })
}

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    http: {
      get() {
        return _axios;
      }
    },
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;



// WEBPACK FOOTER //
// ./src/https/axios.js